import React from 'react';
import { useYouTubePlaylist } from '../hooks/useYouTubePlaylist';

// A plain embed, used for single videos and whenever the IFrame API is
// unavailable. `embed_url` is built server-side and used verbatim.
const PlainEmbed = ({
  option
}) => React.createElement("iframe", {
  title: option.name,
  src: option.embed_url,
  allow: "accelerometer; autoplay; encrypted-media; picture-in-picture",
  allowFullScreen: true
});

// The playlist's own queue, read back off the player rather than fetched.
const Rail = ({
  name,
  ids,
  titles,
  index,
  onPlay
}) => React.createElement("div", {
  className: "cp-ytrail"
}, React.createElement("div", {
  className: "cp-ytrail-head"
}, React.createElement("span", {
  className: "cp-ytrail-name"
}, name), React.createElement("span", {
  className: "cp-ytrail-count"
}, ids.length ? `${index + 1} / ${ids.length}` : 'Loading…')), React.createElement("div", {
  className: "cp-ytrail-list"
}, ids.map((id, i) => {
  const on = i === index;
  return React.createElement("button", {
    type: "button",
    key: id,
    className: `cp-ytrow${on ? ' is-on' : ''}`,
    onClick: () => onPlay(i),
    "aria-label": `Play video ${i + 1}`
  }, React.createElement("span", {
    className: "cp-ytthumb",
    style: {
      backgroundImage: `url(https://i.ytimg.com/vi/${id}/mqdefault.jpg)`
    }
  }, React.createElement("span", {
    className: "cp-ytthumb-scrim"
  }), React.createElement("span", {
    className: "cp-ytbadge"
  }, i + 1)), React.createElement("span", {
    className: "cp-ytmeta"
  }, React.createElement("span", {
    className: "cp-yttitle"
  }, titles[id] || `Video ${i + 1}`), React.createElement("span", {
    className: "cp-ytsub"
  }, on ? 'Now playing' : 'Tap to play')));
})));
const WithRail = ({
  option,
  listId
}) => {
  const {
    mountRef,
    ids,
    titles,
    index,
    failed,
    playAt
  } = useYouTubePlaylist(listId);
  return React.createElement("div", {
    className: `cp-higrid${failed || !ids.length ? ' is-solo' : ''}`
  }, React.createElement("div", {
    className: "cp-playerbox"
  }, React.createElement("div", {
    className: "cp-player"
  }, failed ? React.createElement(PlainEmbed, {
    option: option
  }) : React.createElement("div", {
    ref: mountRef,
    className: "cp-playermount"
  }))), !failed && ids.length > 0 && React.createElement(Rail, {
    name: option.name,
    ids: ids,
    titles: titles,
    index: index,
    onPlay: playAt
  }));
};

/**
 * The drawer's player. A playlist gets its queue listed beside it; a single
 * video (reels) has no queue, so it stays a plain embed.
 */
const PlaylistPane = ({
  option
}) => {
  let listId = null;
  try {
    listId = new URL(option.embed_url).searchParams.get('list');
  } catch (e) {
    listId = null;
  }
  return React.createElement(React.Fragment, null, listId ? React.createElement(WithRail, {
    option: option,
    listId: listId
  }) : React.createElement("div", {
    className: "cp-higrid is-solo"
  }, React.createElement("div", {
    className: "cp-playerbox"
  }, React.createElement("div", {
    className: "cp-player"
  }, React.createElement(PlainEmbed, {
    option: option
  })))), option.open_url && React.createElement("a", {
    className: "cp-openlink",
    href: option.open_url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Open on YouTube"));
};
export default PlaylistPane;
